module.exports = __webpack_public_path__ + "images/emoji/large_orange_diamond.cd2b92ba5c2e886ba49d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/large_orange_diamond.png
// module id = 1rLK
// module chunks = 2